module.exports = __webpack_public_path__ + "static/testimonialForm-guy-5f9ad394a42e1403d6400cccca0226b3.png";